export default {
	common: {
		webName: 'MiraStudent',
		login: '로그인',
		startImmediately: '지금 시작하기',
		delete: '삭제',
		experienceClass: '체험 수업',
		enter: '입력하세요',
		cancel: '취소',
		confirm: '확인',
		select: '선택하세요',
		operationSuccessful: '작업 성공',
		upload: '업로드',
		classID: '수업 ID',
		wantToDelete: '정말 삭제하시겠습니까?',
		studyReport: '학습 리포트',
		submit: '제출',
		userCenter: '개인 센터',
		setting: '설정',
		updataSuccess: '제출 성공, 심사 대기 중',
		balance: 'Mira 잔액',
		simplifiedChinese: '간체 중국어',
		traditionalChinese: '번체 중국어',
		English: '영어',
		Japanese: '일본어',
		Korean: '한국어',
		courseCancelled: '수업 취소됨',
		contactTeacher: '선생님 연락',
		numberClass: '{num}회 수업',
		endTime: '만료 시간',
		setSuccess: '설정 성공',
		studentsUpload: '학생 업로드',
		teacherUpload: '선생님 업로드',
		hour: '시간',
		class: '회',
		fivetyminutes: '50분'
	},
	headers: {
		searchTeachers: '선생님 검색',
		recommendTeachers: '추천 선생님',
		becomeTeacher: '선생님 되기',
		teacherPortal: '선생님 입구',
		balance: 'MIRA 잔액'
	},
	footers: {
		about: '소개',
		pavilionToUs: '회사 소개',
		used: '사용 방법',
		becomeTeacher: '선생님 되기',
		naturalResources: '리소스',
		study: '학습 칼럼',
		help: '도움말',
		contactUs: '문의하기',
		questions: '자주 묻는 질문',
		pay: '결제 방법',
		refund: '환불 정책',
		socialize: 'MiraStudent 소셜'
	},
	mainIndex: {
		titleOne: '1대1 전문 선생님',
		titleTwo: '맞춤형 교육·상호작용 집중 학습',
		titleThree: '온라인 과외 플랫폼',
		titleFour: 'MiraStudent는 온라인 과외 플랫폼으로, 교육 기술로 지역과 시간의 한계를 넘어 학생이 집에서 편안하게',
		titleFive: '전문 선생님의 지도를 받을 수 있도록 하여 시간을 절약하고 학습 효율과 능력을 향상시켜 시험을 쉽게 대비할 수 있습니다!',
		titleSubject: '인기 과외 과목',
		viewMore: '더 보기',
		invitationalEducation: '학습 잠재력을 이끌어낼 선생님 찾기',
		introduce: '등록된 선생님, 전문 과목 선생님, 언어 전문가, 사회 전문가가 있어 다양한 학습 요구를 해결해 드립니다',
		reasonForSelection: 'MiraStudent를 선택하는 이유',
		reasonTitleOne: '우수한 교사진',
		reasonContentOne: '모든 선생님은 엄격한 심사를 거쳐 신원, 이력 및 학력이 확인되었으며 대부분 등록된 교사로 전문 과목 경험이 있습니다',
		reasonTitleTwo: '자유롭고 편안한 학습',
		reasonContentTwo: '기존 오프라인 학습의 틀을 깨고 온라인에서 언제 어디서나 수업을 들어 출퇴근의 어려움 없이 부담 없이 즐겁게 학습합니다',
		reasonTitlethree: '맞춤형 전용 과정',
		reasonContentThree: '1대1 전문 선생님\n나만을 위한 맞춤형 과정 제작\n학습 흥미를 키우고 시험 대응 능력을 향상시킵니다',
		reasonTitlefour: '합리적 공정한 요금',
		reasonContentFour: '수업료는 선생님이 자유롭게 책정하므로 예산에 맞춰 적합한 수업을 선택할 수 있습니다. 수업이 만족스럽지 않다면 남은 수업료를 환불 신청할 수 있습니다',
		classProcess: '수업 절차',
		processOne_1: '적합한 선생님 찾기',
		processOne_2: '선생님의 이력, 자기소개 영상, 학생 평가를 보고 적합한 선생님을 선택합니다',
		processOne_3: '정규 수업 전, 선생님과 소통하고 「체험 수업」을 구매하여 선생님과 잘 맞는지 시험해 보세요',
		processTwo_1: '수업 예약',
		processTwo_2: '수업 구매 후, 선생님의 일정표에서 열린 시간을 예약하고 확인을 기다립니다',
		processTwo_3: '학생은 수업 24시간 전까지 예약 변경 또는 취소가 가능합니다',
		processThree_1: '수업 시작',
		processThree_2: '학생은 수업 전 MT 계정에서 선생님의 노트(있는 경우)를 다운로드할 수 있습니다. 수업 시간이 되면 학생은 컴퓨터, 휴대폰 또는 태블릿으로 MT 계정에서 VOOV 화상 교실을 열어 수업을 들을 수 있습니다. 수업 완료 후 과제가 있는 경우, 학생은 MT 계정에서 다운로드하여 완료 후 웹사이트에 다시 업로드하여 선생님이 채점할 때까지 기다립니다',
		obtainIncome: '학생과 전문 지식을 공유하여 수익 창출',
		onlineTeaching: 'MiraStudent 온라인 수업 시작을 위해 등록하세요',
		evaluate: 'MiraStudent 학생들의 평가 들어보기'
	},
	cashDesk: {
		cashRegister: '계산대',
		goods: '상품',
		subject: '과목',
		category: '카테고리',
		time: '시간',
		classNum: '수업 횟수',
		total: '소계',
		single: '단일 수업',
		discount: '할인',
		selectCoupon: '쿠폰 선택',
		noCoupon: '선택 안 함',
		couponDiscount: '체험 수업 구매 시 할인',
		totalCount: '총액',
		paymentMethod: '결제 방법',
		payment: 'MT 코인 사용',
		balance: '잔액',
		noBalance: '잔액 부족, 클릭하여 충전',
		pay: '확인 및 결제',
		purchaseSuccessful: '구매 성공'
	},
	forStudy: {
		skipQuestion: '질문 건너뛰기',
		chooseMentor: '직접 선생님 선택',
		studyFor: '무엇을 배우고 싶으세요?',
		budget: '수업 당 예산은?',
		country: '국가/지역은?',
		classTime: '수업 시간은?',
		mentorLevel: '선생님 레벨?',
		motherTongue: '원어민?',
		masterLanguage: '함께 구사하는 언어?',
		weekMon_weekFri: '월요일~금요일',
		weekend: '토요일, 일요일',
		anyTime: '언제든지'
	},
	forClassIndex: {
		languageLevel: '언어 수준',
		onlineTeacher: '온라인 영어 선생님',
		seacher: '선생님 이름 또는 키워드 검색',
		class: '수업',
		pleaseSelect: '선택하세요',
		budget: '수업 당 학습 예산',
		country: '국가/지역',
		classTime: '수업 시간',
		schedulingPeriod: '일정 기간',
		mentorLevel: '선생님 레벨',
		brfore: '이전',
		motherTongue: '원어민',
		masterLanguage: '함께 구사하는 언어',
		suitable: '님의 요구에 맞는 선생님',
		new: 'NEW',
		highQualityMentor: '명 우수 선생님',
		seniorTutor: '시니어 선생님',
		professionalTeacher: '전문 선생님',
		professor: '교수',
		speek: '구사 가능',
		learnMore: '자세히 보기',
		minute: '분',
		poetryHall: '시당',
		trialClass: '체험 수업 예약',
		contactMentor: '선생님 연락',
		viewClass: '전체 수업 일정 보기'
	},
	personalizationTeacher: {
		seacherTeacher: '나만의 맞춤 선생님 찾기',
		hint: '1분만 투자해 간단한 질문에 답하면 가장 적합한 선생님을 매칭하는 데 도움이 됩니다',
		studyFor: '학습 목적은 무엇인가요?',
		start: '시작',
		selectTeacher: '직접 선생님 선택'
	},
	teacherVue: {
		information: '{name} 정보',
		teachingSubjects: '가르치는 과목',
		professorlevel: '교수 레벨',
		highestEducationLevel: '최종 학력',
		experience: '특수 교육 경험',
		aboutMe: '자기소개',
		videoIntroduction: '영상 소개',
		cannotPlay: '비디오 재생 미지원',
		classTime: '수업 시간',
		resume: '이력서',
		evaluate: '평가',
		myClass: '내 수업',
		testClassTime: '1회 25분 수업',
		formalClasses: '정규 수업',
		formalClassTime: '{number}회 50분 수업',
		priceAdjustment: '{time}에 선생님 수업 가격 조정 예정'
	},
	login: {
		login: '로그인',
		welcome: 'MiraStudent에 오신 것을 환영합니다!',
		hint: '아래 방법으로 계속 로그인하거나 계정을 생성하시면 MiraStudent 서비스 약관 및 개인정보 처리방침에 동의하는 것으로 간주됩니다.',
		loginMethod: '{way}로 로그인',
		or: '또는',
		email: '이메일',
		emailAccount: '이메일 주소',
		password: '비밀번호',
		passwordPlaceholder: '비밀번호 입력',
		forgotPassword: '비밀번호 찾기',
		rememberMe: '로그인 상태 유지',
		toLogin: '로그인',
		noAccount: '아직 계정이 없으신가요?',
		register: '등록',
		editPassword: '비밀번호 변경',
		retry: '{countdown}초 후 다시 시도',
		send: '인증번호 전송',
		code: '인증번호',
		codePlaceholder: '인증번호 입력'
	},
	studentsCom: {
		calendar: '캘린더',
		month: '월',
		week: '주',
		reportCourseNotCompleted: '수업 미완료 보고',
		situationDescription: '수업이 예상대로 완료되지 않아 죄송합니다. 상황을 설명하기 위해 아래 정보를 사실대로 작성해 주세요',
		whyNotCompleted: '*수업이 완료되지 않은 이유는 무엇인가요?',
		solution: '*예상하는 해결 방법은 무엇인가요?',
		explanation: '설명 및 증명',
		explanationContent: '요청을 지원할 수 있는 증거가 있다면 최상의 결과를 얻을 수 있도록 최대한 많이 제공해 주세요',
		uploadImage: '증거로 최대 5장의 사진 또는 동영상 업로드',

		myClass: '내 수업',
		bookNewClassroom: '새 수업 예약',
		list: '목록',
		waitingClass: '수업 대기 중',
		completed: '완료됨',
		pendingConfirmation: '확인 대기 중인 수업',
		enterClassroom: '교실 입장',
		upcomingCourses: '다가오는 수업',
		waitingConfirm: '선생님 확인 대기 중',
		waitingConfirmstudent: '학생 확인 대기 중',
		confirmAfterClass: '수업 후 확인 대기 중',
		confirmed: '확인됨',
		calendar: '캘린더',

		myWork: '내 과제',
		myNotes: '내 노트',
		myTeacher: '내 선생님',
		reserve: '예약',
		chat: '대화',
		giveExtra: '추가 선물',
		recommendedTeacher: '추천 선생님',
		professionalTeacher: '전문 선생님',
		seniorTeacher: '시니어 선생님',
		myTest: '내 시험',

		resolved: '해결됨',
		selectSolutionTip: '학생과 협의한 해결 방법을 선택하세요. 제출 후 학생이 48시간 내에 확인합니다',
		selectSolution: '해결 방법 선택',
		selectPlaceholder: '선택하세요',
		fillRefundAmount: '환불 금액 입력',
		feeDeductionTip: '해당 수업의 수업료는 먼저 환불 금액을 공제하고, 수수료를 공제한 후 남은 부분이 선생님 지갑으로 입금됩니다',

		teacherEvaluation: '선생님 평가',
		classSatisfaction: '수업 만족도',
		selectTeachingTraits: '선생님 {name}에게 적합한 교수 특성 태그 선택',
		showOnProfileNamed: '이 응답은 선생님 프로필 페이지에 표시됩니다(실명)',
		showOnProfileAnonymous: '이 응답은 선생님 프로필 페이지에 표시됩니다(익명)',
		writeClassExperience: '수업 경험담 작성',
		classFeedback: '선생님 {name}에게 수업 피드백 제공',

		tradingOrder: '거래 주문',
		completedOrders: '완료된 주문',
		refundedOrders: '환불된 주문',
		transactionTime: '거래 시간',
		teacherName: '선생님 이름',
		courseContent: '강좌 내용',
		amount: '금액',
		orderNumber: '주문 번호',

		unresolved: '미해결',
		uploadDataDecision: '증거 업로드 및 플랫폼 결정',
		explanationAndProof: '설명 및 증명',
		uploadEvidenceTip: '요청을 지원할 수 있는 증거가 있다면 최상의 결과를 얻을 수 있도록 최대한 많이 제공해 주세요',
	},
	userMySetting: {
		setting: '설정',
		logOut: '로그아웃',
		basicInfo: '기본 정보',
		photo: '사진',
		uploadAvatarTip: '명확한 개인 프로필 사진을 업로드하세요',
		name: '이름',
		inputNamePlaceholder: '이름 입력',
		gender: '성별',
		selectPlaceholder: '선택하세요',
		male: '남성',
		female: '여성',
		timeZone: '시간대',
		currency: '통화',
		birthday: '생일',
		displayLanguage: '표시 언어',
		country: '소재 국가',
		save: '저장',
		accountVerification: '계정 인증',
		email: '이메일',
		inputEmailPlaceholder: '입력하세요',
		sendVerificationEmail: '인증 이메일 보내기',
		password: '비밀번호',
		editPassword: '비밀번호 변경',
		bindApp: '앱 연동',
		facebook: '페이스북',
		google: '구글',
		wechat: '위챗',
		clickToBind: '클릭하여 연동',
		unbind: '연동 해제',
		confirmLogout: '정말 로그아웃하시겠습니까?',
		logoutContent: '로그아웃',
		confirm: '확인',
		cancel: '취소',
	},
	userMyWallet: {
		myWallet: '내 지갑(학생)',
		recharge: '충전',
		availableBalance: '사용 가능 잔액',
		approximateAmountTip: '*여기에 나열된 금액은 대략적인 금액으로 환율 변동에 따라 약간의 차이가 있을 수 있으며, 모든 금액은 USD 기준입니다',
		walletTransactionDetails: '지갑 거래 내역',
		time: '시간',
		item: '항목',
		amount: '금액',
		orderId: '주문 ID',
		classNumber: '수업 번호'
	},
	userCenter: {
		greeting: '안녕하세요!',
		nickname: '닉네임',
		todolist: '캘린더',
		myCoursesPackage: '내 강좌 패키지',
		myCourses: '내 강좌',
		classBalance: '수업 잔액',
		appointment: '예약',
		viewClass: '수업 보기',
		myCoupons: '내 쿠폰',
		newUserCoupon: '신규 사용자 10달러 할인 쿠폰',
		minimumConsumption: '최소 소비 금액',
		validTime: '사용 가능 시간',
		myHomework: '내 과제',
		completedHomework: '완료된 과제',
		myTest: '내 시험',
		noIncompleteTest: '완료되지 않은 시험 없음',
		learningReport: '학습 리포트',
		personalizedRecommendation: '맞춤 추천',
		todayHot: '오늘의 인기',
		fromUK: '영국 출신',
		nativeLanguage: '모국어',
		hourlyCharge: '시간당 요금',
		ticketPackage: '티켓 패키지',
		discount: '할인',
		recommendationReason: '추천 이유',
		bookNow: '지금 예약',
		toDoList: '할 일 목록',
		timeLimitedOffer: '한정 특가',
		purchase: '구매',
		remainingTime: '남은 시간',
		teacherAppointmentConfirm: '선생님 수업 예약 확인서 발송',
		timeZone: '시간대',
		confirm: '확인',
		reject: '거절',
		reportContent: '건/최근 3개월',
	},
	appointment: {
		appointmentCourse: '수업 예약',
		teacher: '선생님',
		coursePackage: '수업 패키지',
		remainingClasses: '남은 수업 횟수',
		selectedClasses: '선택됨',
		availableClasses: '선택 가능',
		contactTool: '연락 도구',
		selectContactTool: '이것은 선생님이 사용하는 연락 도구입니다. 연락 도구를 선택하세요',
		nextStep: '다음 단계',
		cancel: '취소',
		confirm: '확인',
		reservationSuccess: '예약 성공',
		appointmentClass: '수업 횟수 예약',
		classDate: '수업 날짜',
		time: '시간',
		selectContact: '연락 방법 선택'
	},
	teacherConfirms: {
		week: '요일',
		year: '년',
		month: '월',
		day: '일',
		utcTime: '(UTC+08:00)',
		classId: '수업 ID:',
		language: '언어',
		duration: '소요 시간',
		price: '가격',
		languageCategory: '언어 카테고리',
		languageType: '언어 유형',
		restTimeNote: '일부 선생님은 수업 시간에 5분의 휴식 시간을 포함할 수 있습니다.',
		contactTool: '연락 도구',
		avatar: '아바타 회의 ID',
		password: '비밀번호',
		teacherEntryTime: '선생님 교실 입장 시간:',
		studentEntryTime: '학생 교실 입장 시간:',
		notes: '노트',
		homework: '과제',
		test: '시험',
		uploadHomework: '과제 업로드',
		uploadTest: '시험 업로드',
		pendingTeacherConfirm: '선생님 확인 대기 중',
		yourClassPending: '귀하의 수업은 선생님의 확인을 기다리고 있습니다',
		cancelReschedulePolicy: '취소 또는 재예약을 원하시면 먼저 당사의',
		pendingConfirm: '확인 대기 중',
		classPendingConfirm: '수업 확인 대기 중',
		pendingClass: '수업 대기 중',
		classStartOnTime: '수업은 예약된 시간에 시작됩니다',
		classCompletedPendingConfirm: '완료된 수업 확인 대기 중',
		confirmWithin3Days: '수업 종료 후 3일 이내에 확인하세요. 그렇지 않으면 시스템이 {time}({timeZone})에 자동으로 수업을 확인합니다',
		reportClassNotCompleted: '수업이 예상대로 종료되지 않았다면 "수업 미완료"를 클릭하여 보고할 수 있습니다.',
		completed: '완료됨',
		rateTeacherWithin3Days: '수업 확인 후 3일 이내에 선생님을 평가해 주세요',
		classCompletedCongrats: '축하합니다. 이 수업이 완료되었습니다',
		classNotCompleted: '처리된 수업',
		waitingTeacherProcess: '선생님의 처리 대기 중, 선생님은 {time}({timeZone}) 전에 처리할 예정입니다.',
		classNotCompletedResultConfirm: '수업 미완료 처리 결과 확인',
		processWithin48Hours: '48시간 이내 {time} ({timeZone}) 전에 처리하세요.',
		teacherSolution: '선생님 처리 방법:',
		refundAmount: '환불 금액:',
		agree: '동의',
		applyPlatformRuling: '플랫폼 결정 신청',
		waitingPlatformRuling: '플랫폼 결정 대기 중',
		pleaseWaitPlatform: '플랫폼 처리 대기 중',
		confirmClass: '수업 확인',
		cancelClass: '수업 취소',
		enterClassroom: '교실 입장',
		interruptNote: '중단 시 이 버튼을 다시 눌러 교실에 입장하세요',
		accomplishClass: '수업 완료 확인',
		classNotAccomplished: '수업 미완료',
		rateTeacher: '선생님 평가',
		viewEvaluation: '평가 보기',
		confirmCancel: '정말 취소하시겠습니까?',
		cancelClassText: '수업 취소',
		confirmAction: '확인',
		cancelAction: '취소',
		operationSuccess: '작업 성공',
		confirmAppointment: '예약을 확인하시겠습니까?',
		confirmAppointmentText: '예약 확인',
		enterClassroomText: '교실 입장',
		confirmCompletion: '수업 완료를 확인하시겠습니까?',
		confirmCompletionText: '수업 완료 확인',
		confirmDelete: '정말 삭제하시겠습니까?',
		deleteText: '삭제',
		confirmAgree: '정말 동의하시겠습니까?',
		agreeResultText: '처리 결과 동의',
		confirmPlatformRuling: '플랫폼 결정을 신청하시겠습니까?',
		platformRulingText: '플랫폼 결정 신청',
		policy: '《취소 및 재예약 정책[](@replace=10001)》'
	},
	addClass: {
		addCourse: '수업 추가',
		type: '유형',
		pleaseSelect: '선택하세요',
		courseName: '수업 이름',
		classNumber: '수업 횟수',
		discount: '할인',
		teacherEarningsPerClass: '선생님 수익/회당',
		displayPricePerClass: '표시 가격/회당',
		noDiscount: '없음',
		referenceMarketValue: '참조 시장 가치: 최소 {currency}$80회, 회당 50분',
		cancel: '취소',
		save: '저장',
		confirmCancel: '정말 취소하시겠습니까?',
		saveSuccess: '저장 성공',
		popular: '인기'
	},
	classManage: {
		currentLevel: '현재 레벨',
		upgrade: '다음 업그레이드까지 {hour}시간 남음',
		viewCommissionRatio: '수수료 비율 보기',
		priceAdjustmentNotice: '가격 조정 공지 중',
		setClassTypeAndPrice: '수업 유형 및 가격 설정',
		trialClass: '체험 수업',
		oneClass25Minutes: '1회 25분 수업',
		save: '저장',
		addCourse: ' + 수업 추가',
		confirmDelete: '정말 삭제하시겠습니까?',
		deleteCourse: '이 수업 삭제',
		submitSuccess: '제출 성공, 심사 대기 중',
		operationSuccess: '작업 성공',
		cancel: '취소',
		effectiveTime: '유효 시간',
		revokeModifications: '수정 사항 취소',
		setPrice: '가격 설정'
	},
	myClassTeacher: {
		myClassroom: '내 수업',
		waitingStudentConfirm: '학생 확인 대기 중',
		startingToday: '오늘 시작 예정',
		waitingMyConfirm: '내 확인 대기 중인 수업',
		futureClassroom: '향후 수업',
		completed: '완료됨',
		exception: '예외',
		confirmCancel: '정말 취소하시겠습니까?',
		submitSuccess: '제출 성공',
		operationSuccess: '작업 성공',
		contactTools: '연락 도구',
	},
	myStudents: {
		onCampusStudents: '재학생',
		archivedStudents: '보관된 학생',
		student: '학생',
		learnedCourse: '수강 과목',
		prepaidBalance: '선불 잔액',
		remainingBalance: '잔여 잔액',
		woXueZhiReport: 'Wo Xue Zhi 보고서',
		communication: '소통',
		appointmentClass: '수업 예약',
		learningReport: '학습 리포트',
		pleaseFill: '작성해 주세요',
		operationSuccess: '작업 성공',
		confirm: '확인',
		cancel: '취소',
		classHour: '수업 시간'
	},
	resolved: {
		title: '해결됨',
		solutionInfo: '학생과 합의한 해결 방법을 선택하세요. 제출 후 학생이 48시간 내에 확인합니다',
		selectSolution: '*해결 방법 선택',
		pleaseSelect: '선택하세요',
		none: '없음',
		courseCompleted: '수업 완료됨',
		returnOnce: '1회 반환',
		partialRefund: '부분 환불',
		fillRefundAmount: '*환불 금액 입력',
		feeInfo: '해당 수업의 수업료는 먼저 환불 금액을 공제하고, 수수료를 공제한 후 남은 부분이 선생님 지갑으로 입금됩니다',
		confirm: '확인',
		cancel: '취소',
		confirmResolve: '정말 해결되었나요?',
		resolveText: '해결',
		operationSuccess: '작업 성공'
	},
	schedule: {
		teachingTime: '수업 시간',
		availableTeachingTime: '가능한 수업 시간',
		addTimeSlot: '+시간대 추가',
		generatedTeachingTime: '생성된 가능한 수업 시간:',
		effectiveDate: '유효 날짜',
		always: '항상',
		until: '까지',
		save: '저장',
		confirmDelete: '정말 삭제하시겠습니까?'
	},
	statistics: {
		total: '총계',
		netIncomeTotal: '순수익 총액',
		unparticipatedTrials: '참여하지 않은 시험',
		tutoringHours: '지도 시간',
		averageRating: '평균 평점',
		totalRatings: '총 평점 수',
		totalStudents: '총 학생 수',
		averageClassRating: '평균 수업 평점',
		allCoursesStudentAvgRating: '모든 강좌에 대한 학생 평균 평점',
		hoursPerStudent: '학생당 시간',
		calculationMethod: '지도 시간을 총 학생 수로 나누어 계산됩니다.',
		attendanceStatus: '출결 현황',
		annualPerformanceLast365Days: '최근 365일간의 연간 성과(마지막 업데이트: 2025-02-07)',
		profileViews: '프로필 조회수',
		studentConversionRate: '학생 전환율',
		effectiveClassHours: '유효 수업 시간',
		hourlyRate: '시간당 요금',
		newStudents: '신규 학생',
		activeStudents: '활동 학생',
		classHoursPerActiveStudent: '활동 학생당 수업 시간',
		trialClassRating: '체험 수업 평점',
		allTime: '전체 기간',
		thisMonth: '이번 달',
		thisWeek: '이번 주',
		downloadIncomeReport: '수익 보고서 다운로드'
	},
	teacherSet: {
		teacherAccountSetting: '선생님 계정 설정',
		cloaking: '숨김',
		uncloaking: '숨김 해제',
		setToCloaking: '숨김으로 설정',
		cancelCloaking: '숨김 취소',
		teacherInfo: '선생님 정보',
		avatar: '프로필 사진',
		name: '이름',
		surname: '성',
		speakLanguages: '구사 가능 언어(다중 선택 가능)',
		select: '선택하세요',
		level: '레벨',
		professorLevel: '교수 레벨',
		specialEducationExperience: '특수 교육 경험',
		educationBackground: '학력',
		certificate: '자격증',
		synopsis: '한 줄 소개',
		selfIntroduction: '자기 소개',
		imageIntroduction: '이미지 소개',
		video: '동영상',
		uploadVideo: '동영상 업로드',
		inputYoutubeLink: 'Paypal 계정 입력',
		inputzhuanshukuai: 'FPS 계정 입력',
		confirm: '확인',
		cancel: '취소',
		save: '저장',
		dataUnderReview: '데이터 심사 중, 다시 제출하지 마십시오...',
		paymentMethod: '지급 방법',
		paypal: 'Paypal',
		zhuanshukuai: 'FPS',
		contactTools: '연락 도구',
		zoom: '줌',
		meetingLink: '회의 링크',
		personalMeetingNumber: '개인 회의 번호(PMI)',
		meetingRoomPassword: '회의실 비밀번호',
		voov: 'VOOV',
		submitSuccess: '제출 성공'
	},
	unresolved: {
		platformProcessing: '미해결 신청 제출 후 플랫폼에서 처리',
		unresolved: '미해결'
	},
	viewCommission: {
		commissionRatio: '수수료 비율',
		level: '레벨',
		hours: '시간',
		mtExtraction: 'MT 수수료',
		classCalculationNote: '50분 수업은 1시간으로 계산, 체험 수업은 미포함',
		gotIt: '알겠습니다'
	},
	wallet: {
		myWalletTeacher: '내 지갑(선생님)',
		withdraw: '출금',
		availableBalance: '사용 가능 잔액',
		totalBalance: '총 잔액',
		pendingBalance: '대기 중 잔액',
		approximateAmountNote: '*여기에 나열된 금액은 대략적인 금액으로 환율 변동에 따라 약간의 차이가 있을 수 있으며, 모든 금액은 USD 기준입니다',
		walletTransactionDetails: '지갑 거래 내역',
		withdrawalDetails: '출금 내역',
		time: '시간',
		item: '항목',
		amount: '금액({currency})',
		courseId: '강좌 ID',
		status: '상태',
		cancelWithdrawal: '출금 취소',
		myWalletTutor: '내 지갑(선생님)',
		transferToStudentWallet: '학생 지갑으로 이체',
		withdrawFromInternalAccount: '내부 계정에서 출금',
		transferMethod: '이체 방법',
		paypal: 'Paypal',
		fps: 'FPS',
		email: '이메일',
		enter: '입력하세요',
		withdrawAmount: '출금 금액',
		maxWithdraw: '최대 출금 가능 금액 {amount}{currency}',
		cancel: '취소',
		withdrawProfit: '수익 출금',
		transferToStudent: '학생 지갑으로 이체',
		confirm: '확인',
		operationSuccess: '작업 성공',
		confirmCancel: '정말 취소하시겠습니까?',
	},
	becomeTeacher: {
		becomeTeacher: '선생님 되기',
		fillPersonalInfo: '1 개인 정보 작성',
		uploadPhoto: '2 사진 업로드',
		uploadCertificate: '3 자격증 업로드',
		fillEducation: '4 학력 작성',
		fillIntroduction: '5 자기 소개 작성',
		uploadVideo: '6 동영상 업로드',
		fillTeachingTime: '7 수업 시간 작성',
		fillTuition: '8 수업료 작성',
		startCreateProfile: '공개 선생님 프로필 생성 시작. 각 섹션을 완료하면 진행 상황이 자동 저장됩니다. 언제든지 돌아와 등록을 완료할 수 있습니다',
		name: '이름',
		pleaseFill: '작성해 주세요',
		surname: '성',
		speakLanguages: '구사 가능 언어(다중 선택 가능)',
		level: '레벨',
		professorLevel: '교수 레벨',
		specialEducationExperience: '특수 교육 경험',
		nextStep: '다음 단계',
		photo: '사진',
		previousStep: '이전 단계',
		certificate: '자격증',
		education: '학력',
		synopsis: '한 줄 소개',
		selfIntroduction: '자기 소개',
		imageIntroduction: '이미지 소개',
		inputYoutubeLink: 'YouTube 링크 입력',
		confirm: '확인',
		teachingTime: '수업 시간',
		availableTeachingTime: '가능한 수업 시간',
		addTimeSlot: '+시간대 추가',
		generatedTeachingTime: '생성된 가능한 수업 시간:',
		effectiveDate: '유효 날짜',
		always: '항상',
		until: '까지',
		setClassTypeAndPrice: '수업 유형 및 가격 설정',
		viewCommissionRatio: '수수료 비율 보기',
		trialClass: '체험 수업',
		one25MinClass: '1회 25분 수업',
		formalClass: '정규 수업',
		addCourse: '+ 수업 추가',
		submit: '제출',
		submitSuccess: '제출 성공, 심사 대기 중',
		hint1: '이름을 입력하세요',
		hint2: '성을 입력하세요',
		hint3: '구사 가능 언어와 레벨을 선택하세요',
		hint4: '교수 레벨을 선택하세요',
		hint5: '특수 교육 경험을 선택하세요',
	},
	teacherIndex: {
		teacherCenter: '선생님 센터',
		myClass: '내 수업',
		myStudents: '내 학생',
		classManagement: '수업 관리',
		schedule: '일정',
		statistics: '통계',
		wallet: '지갑',
		settings: '설정',
	},
	statusConfirms: {
		appointmentCourse: '수업 예약',
		teacher: '선생님',
		coursePackage: '수업 패키지',
		remainingClasses: '남은 수업 횟수',
		selectContactTool: '이것은 선생님이 사용하는 연락 도구입니다. 연락 도구를 선택하세요',
		contactTool: '연락 도구',
		nextStep: '다음 단계',
		confirmReservation: '예약 확인',
		cancel: '취소',
		confirm: '확인',
		selectContactWay: '연락 방법 선택',
		reservationSuccess: '예약 성공',
		week: '요일',
		hoursFormat: '{start} / {end}',
		classId: '수업 ID:',
		courseName: '수업 이름',
		language: '언어',
		duration: '소요 시간',
		price: '가격',
		languageCategory: '언어 카테고리',
		languageType: '언어 유형',
		breakNote: '일부 선생님은 수업 시간에 5분의 휴식 시간을 포함할 수 있습니다.',
		contactToolSection: '연락 도구',
		meetingId: '회의 ID',
		password: '비밀번호',
		teacherEntryTime: '선생님 교실 입장 시간:',
		studentEntryTime: '학생 교실 입장 시간:',
		notes: '노트',
		uploadNotes: '노트 업로드',
		homework: '과제',
		uploadHomework: '과제 업로드',
		test: '시험',
		uploadTest: '시험 업로드',
		waitingStudentConfirmClass: '귀하의 수업은 학생의 확인을 기다리고 있습니다',
		waitingStudentConfirm: '학생 확인 대기 중',
		waitingConfirm: '확인 대기 중',
		waitingClass: '수업 대기 중',
		classCompletedConfirm: '완료된 수업 확인 대기 중',
		classCompleted: '완료됨',
		classNotCompleted: '처리된 수업',
		studentConfirm: '학생이 수업 종료 후 3일 이내에 확인합니다. 그렇지 않으면 시스템이 {finish_time}({timeZone})에 자동으로 수업을 확인합니다.',
		studentMarkedNotCompleted: '학생이 수업 미완료로 표시했습니다. {time}({timeZone}) 전에 처리해 주세요. 다음은 학생 작성 내용입니다',
		notCompletedReason: '{reason} 이유로 수업 미완료, {expectedResult}를 희망합니다',
		content: '{content}',
		resolved: '해결됨',
		unresolved: '미해결',
		waitingPlatformDecision: '플랫폼 결정 대기 중',
		confirmCourse: '수업 확인',
		cancelClass: '수업 취소',
		enterClassroom: '교실 입장',
		reenterNote: '중단 시 재입장',
		accomplishCourse: '수업 완료 확인',
		courseNotCompleted: '수업 미완료',
		confirmCancel: '정말 취소하시겠습니까?',
		operationSuccess: '작업 성공',
		cancelAndReschedulePolicy: '《취소 및 재예약 정책》',
		teacherhandlingplan: '선생님 처리 방법',
		refundAmount: '환불 금액',
		processWithin48Hours: '학생 확인 대기 중. 학생이 48시간 이내 {time}({timeZone})까지 처리합니다.',
		result1: '수업 완료됨',
		result2: '1회 반환',
		result3: '부분 환불'
	},
	classTime: {
		selectCourseStartTime: '수업 시작 시간 선택({timeZone})',
		obtained: '획득함',
		noCourse: '수업 없음',
	},
	introductionTeacher: {
		introduceTeacher: '선생님 소개',
		recommendTeacherTip: '추천 선생님 사용자 이름을 작성할 수 있습니다. 플랫폼 승인 후 첫 3개월 동안 추천된 선생님이 획득한 시간은 귀하의 누적 시간에도 추가됩니다',
		recommendTeacher: '선생님 추천',
		inputTeacherEmail: '선생님 이메일 계정 입력',
		confirm: '확인',
		recommendedTeachers: '추천된 선생님',
		pendingReview: '심사 대기 중',
		close: '닫기',
		operationSuccess: '작업 성공'
	},
	recharge: {
		recharge: '충전',
		rechargeAmount: '충전 금액',
		inputPrompt: '입력하세요',
		thirdPartyFee: '제3자 결제 수수료(환불 불가) + 5%',
		totalPrice: '총액',
		cancel: '취소',
		submit: '제출',
		confirmRecharge: '정말 충전하시겠습니까?',
		rechargeBalance: '잔액 충전',
		rechargeSuccess: '충전 성공'
	}
}